
import React, { useState } from "react";

import "./EvaLiveExpert.css";

import EvaLiveExpertSimli from "./EvaLiveExpertSimli";
import EvaLiveExpertTavus from "./EvaLiveExpertTavus";


//========================================================
// Eva Avatar Provider
//========================================================

const EVA_AVATAR_PROVIDER = "TAVUS";

// Default provider:
// "TAVUS"
// "SIMLI"


//========================================================
// Eva Live Expert
//========================================================

export default function EvaLiveExpert()
{

    //----------------------------------------------------
    // State
    //----------------------------------------------------

    const [provider, setProvider] = useState(
        EVA_AVATAR_PROVIDER
    );


    //----------------------------------------------------
    // Change Provider
    //----------------------------------------------------

    const switchProvider = (nextProvider) =>
    {
        if (nextProvider === provider)
        {
            return;
        }

        setProvider(nextProvider);
    };


    //----------------------------------------------------
    // Render
    //----------------------------------------------------

    return (

        <div className="eva-avatar-provider-root">

            {/*===============================================
              Provider Switch
            ===============================================*/}

            <div className="eva-avatar-provider-switch">

                <span className="eva-avatar-provider-label">
                    AVATAR
                </span>

                <div className="eva-avatar-provider-buttons">

                    <button
                        type="button"
                        className={
                            "eva-avatar-provider-button " +
                            (provider === "TAVUS"
                                ? "active"
                                : "")
                        }
                        onClick={() => switchProvider("TAVUS")}
                    >
                        Tavus
                    </button>

                    <button
                        type="button"
                        className={
                            "eva-avatar-provider-button " +
                            (provider === "SIMLI"
                                ? "active"
                                : "")
                        }
                        onClick={() => switchProvider("SIMLI")}
                    >
                        Simli
                    </button>

                </div>

            </div>


            {/*===============================================
              Active Avatar
            ===============================================*/}

            <div className="eva-avatar-provider-content">

                {provider === "TAVUS" ? (

                    <EvaLiveExpertTavus
                        key="tavus"
                    />

                ) : (

                    <EvaLiveExpertSimli
                        key="simli"
                    />

                )}

            </div>

        </div>

    );

}
